import { useQuery } from 'react-query'
import { BASE_API_URL } from 'constants/env'
import { API_METHODS } from 'constants/api-methods'
import { apiHeaders } from 'utils/api-headers'
import { store } from 'index'
import { handleErrors } from 'utils/handle-errors'
import {
  PnsMacMiniUser,
  PaginatedMacMiniUserResponse,
} from 'interfaces/pns-mac-mini-user'

interface MacMiniUserFilters {
  page?: number // We'll convert this to offset internally
  limit?: number
  macMiniId?: string
  macMiniUserId?: string
  status?: string
  wispStatus?: string
  usernameSearch?: string
  serviceFqdnSearch?: string
  minWispPort?: number
  maxWispPort?: number
  terminalId?: string
  ansibleId?: string
  lastActivityAfter?: string
  lastActivityBefore?: string
  hasPhysicalPhones?: boolean
  include?: string
  sortBy?: string
  sortOrder?: 'asc' | 'desc'
}

const fetchMacMiniUsers = async (
  filters: MacMiniUserFilters = {}
): Promise<PaginatedMacMiniUserResponse> => {
  const params = new URLSearchParams()

  // Convert page to offset (PNS uses offset-based pagination)
  if (filters.page && filters.limit) {
    const offset = (filters.page - 1) * filters.limit
    params.append('offset', offset.toString())
  }
  if (filters.limit) params.append('limit', filters.limit.toString())
  if (filters.macMiniId) params.append('macMiniId', filters.macMiniId)
  if (filters.macMiniUserId)
    params.append('macMiniUserId', filters.macMiniUserId)
  if (filters.status) params.append('status', filters.status)
  if (filters.wispStatus) params.append('wispStatus', filters.wispStatus)
  if (filters.usernameSearch)
    params.append('usernameSearch', filters.usernameSearch)
  if (filters.serviceFqdnSearch)
    params.append('serviceFqdnSearch', filters.serviceFqdnSearch)
  if (filters.minWispPort)
    params.append('minWispPort', filters.minWispPort.toString())
  if (filters.maxWispPort)
    params.append('maxWispPort', filters.maxWispPort.toString())
  if (filters.terminalId) params.append('terminalId', filters.terminalId)
  if (filters.ansibleId) params.append('ansibleId', filters.ansibleId)
  if (filters.lastActivityAfter)
    params.append('lastActivityAfter', filters.lastActivityAfter)
  if (filters.lastActivityBefore)
    params.append('lastActivityBefore', filters.lastActivityBefore)
  if (filters.hasPhysicalPhones !== undefined)
    params.append('hasPhysicalPhones', filters.hasPhysicalPhones.toString())
  if (filters.include) params.append('include', filters.include)
  if (filters.sortBy) params.append('sortBy', filters.sortBy)
  if (filters.sortOrder) params.append('sortOrder', filters.sortOrder)

  let response = await fetch(
    `${BASE_API_URL}/api/v4/phone_number_service/mac_mini_users?${params.toString()}`,
    {
      method: API_METHODS.GET,
      headers: apiHeaders(store.getState()),
    }
  )

  response = handleErrors(response)

  return response.json()
}

const useMacMiniUsers = (
  filters: MacMiniUserFilters = {},
  enabled: boolean = true
) => {
  return useQuery(
    ['mac-mini-users', filters],
    () => fetchMacMiniUsers(filters),
    {
      enabled,
      staleTime: 30000,
      retry: 2,
    }
  )
}

export default useMacMiniUsers
